import { GQL } from "@binale-tech/shared";

import { summarizeAutoSort } from "@dms/components/DmsAutoSort/autoSortSummary";
import { DmsType } from "@domain/models/dms";

import { withThinking } from "../runner/runAgent";
import type { AgentStep } from "../runner/types";
import { MAX_IDS_PER_JOB } from "./draftSelection";
import { sendInChunks } from "./paging";

export const autoSortStep: AgentStep = {
    id: "autoSort",
    product: [GQL.IProductKey.Dms],
    async run(ctx, io) {
        const ids = [...ctx.documents().values()]
            .filter((doc) => doc.type === DmsType.new_documents && doc.aiStatus?.status === "done")
            .map((doc) => String(doc.key));
        if (ids.length === 0) return { status: "nothing" };

        const results = await withThinking(io, "app.agent.autoSort.thinking", () =>
            sendInChunks(ids, MAX_IDS_PER_JOB, (chunk) => ctx.autoSort(chunk)),
        );
        ctx.autoSortResults = results;

        const { moved } = summarizeAutoSort(results);
        io.post({ kind: "done", textId: "app.agent.autoSort.done", values: { moved, total: results.length } });
        return {
            status: "done",
            summary: [{ textId: "app.agent.report.sorted", values: { moved, total: results.length } }],
        };
    },
};
